<div class="ind-container">
  <div class="ind-item-container">
    <div class="ind-item-input-container">
      <mat-form-field appearance="outline" class="ind-form-field">
        <mat-label>Indications for therapeutic claim</mat-label>
        <input matInput #indTherapeuticClaimInput [(ngModel)]="therapClaimInd" class="ind-item ind-item-input"
          (keyup.enter)="updateTherapClaimInd($event)" (keyup.escape)="cancelUpdate()" (blur)="updateTherapClaimInd($event)" />
        <mat-icon matSuffix (mousedown)="clearTherapClaimIndField()">cancel</mat-icon>
      </mat-form-field>
    </div>
  </div>
</div>
